var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-logo-container",
      class: { collapse: _vm.collapse }
    },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          _vm.collapse
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  class:
                    "sidebar-logo-link" +
                    (_vm.tenantId === 4039 ? " sidebar-logo-4039" : ""),
                  attrs: { to: "/" }
                },
                [
                  _vm.logo
                    ? _c("img", {
                        staticClass: "sidebar-logo-collapse",
                        attrs: { src: _vm.logo }
                      })
                    : _c("h1", { staticClass: "sidebar-title" }, [
                        _vm._v(_vm._s(_vm.title) + " ")
                      ])
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  class:
                    "sidebar-logo-link" +
                    (_vm.tenantId === 4039 ? " sidebar-logo-4039" : ""),
                  style: { textAlign: _vm.tenantId === 18182 ? "center" : "" },
                  attrs: { to: "/" }
                },
                [
                  _vm.tenantId === 18182
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        staticStyle: {
                          width: "auto",
                          padding: "5px 30px 5px 0"
                        },
                        attrs: { src: _vm.logo }
                      })
                    : _vm.tenantId === 4039
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        staticStyle: {
                          width: "auto",
                          padding: "5px 30px 5px 18px"
                        },
                        attrs: { src: _vm.logo }
                      })
                    : _vm.logo
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        attrs: { src: _vm.logo }
                      })
                    : _c("h1", { staticClass: "sidebar-title" }, [
                        _vm._v(_vm._s(_vm.title) + " ")
                      ])
                ]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }